/* PKF — Barre sticky "Ajouter au panier" (pages produit).
   Clique le VRAI bouton natif Horizon (flux d'ajout natif complet : validation
   stock, animations, événement cart:update → drawer PKF). Exclut les boutons
   quick-add des product-cards pour ne jamais ajouter le mauvais produit. */
(function () {
  if (typeof window === 'undefined') return;

  function findMainButton() {
    var list = document.querySelectorAll(
      'product-form-component button[ref="addToCartButton"], product-form button[type="submit"], .product-form__submit'
    );
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('product-card, .quick-add-modal, dialog, quick-add-component')) return list[i];
    }
    return null;
  }

  function init() {
    var btn = findMainButton();
    var bar = document.querySelector('.pkf-sticky-cart');
    if (!btn || !bar) return;
    var stickyBtn = bar.querySelector('.pkf-sticky-cart__btn');
    if (!stickyBtn) return;

    var baseLabel = stickyBtn.textContent;
    var busy = false;
    var rearmTimer = null;

    /* Reflète l'état du bouton natif (variante épuisée → désactivé) */
    function mirror() {
      var b = findMainButton();
      var disabled = !b || b.disabled;
      if (busy) return;
      stickyBtn.disabled = disabled;
      stickyBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      stickyBtn.textContent = disabled ? 'Épuisé' : baseLabel;
    }
    try {
      new MutationObserver(mirror).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    } catch (e) {}
    document.addEventListener('variant:update', function () { setTimeout(mirror, 60); });

    /* Anti double-tap : busy jusqu'au prochain cart:update (ou 5 s) */
    function rearm() {
      busy = false;
      if (rearmTimer) { clearTimeout(rearmTimer); rearmTimer = null; }
      mirror();
    }
    document.addEventListener('cart:update', rearm);

    stickyBtn.addEventListener('click', function () {
      var b = findMainButton();
      if (busy || !b || b.disabled) return;
      busy = true;
      stickyBtn.disabled = true;
      stickyBtn.textContent = 'Ajout…';
      rearmTimer = setTimeout(rearm, 5000);
      b.click();
    });

    /* Visibilité : la barre apparaît quand le bouton principal sort de l'écran.
       inert quand cachée → pas de bouton invisible atteignable au clavier. */
    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      try { bar.toggleAttribute('inert', !show); } catch (e) {}
    }
    setVisible(false);
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) { setVisible(!e.isIntersecting); });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0 }
    );
    io.observe(btn);

    mirror();
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
